import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { contact, images } from '../data/site';
export function CtaBanner() {
  return <section className="relative isolate w-full overflow-hidden bg-ink" data-id="element-156" data-mp="18j8irrvgokis">
      <img src={images.lot} alt="Hold Fast Hauling Freightliner Cascadia and Utility 3000R reefer staged for dispatch" className="absolute inset-0 h-full w-full object-cover" data-id="element-157" data-mp="13m9lx1kexzgw" />
      <div className="absolute inset-0" aria-hidden="true" style={{
      background: 'linear-gradient(to right, rgba(11,14,17,0.94) 0%, rgba(11,14,17,0.78) 55%, rgba(11,14,17,0.5) 100%)'
    }} data-id="element-158" data-mp="1w8ky79hdtotj" />

      <div className="relative mx-auto max-w-[1280px] px-6 py-24 lg:px-10 lg:py-32" data-id="element-159" data-mp="1he6cv2aci3bp">
        <Reveal data-id="element-160" data-mp="ax2ne2kyl9vn">
          <div className="max-w-2xl" data-id="element-161" data-mp="axks7nloswf6">
            <h2 className="font-display text-3xl font-extrabold leading-[1.05] tracking-tightest text-white sm:text-4xl lg:text-[3.2rem]" data-id="element-162" data-mp="aym41uaj1mxy">
              Have Freight That Needs to Move?
            </h2>
            <p className="mt-6 max-w-lg text-base leading-relaxed text-white/70" data-id="element-163" data-mp="1b6pzcncc39cs">
              Tell us what you&apos;re shipping, where it&apos;s going, and when it needs to arrive.
            </p>
            <div className="mt-10 flex flex-wrap items-center gap-6" data-id="element-164" data-mp="11cpo03qgl7vm">
              <a href="#contact" className="group inline-flex items-center gap-2 rounded-full bg-ice px-8 py-4 text-[13px] font-bold uppercase tracking-[0.1em] text-white transition-colors duration-150 ease-premium hover:bg-ice-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-ink" data-id="element-165" data-mp="168eoqae7suti">
                Request a Quote
                <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-premium group-hover:translate-x-1" data-id="element-166" data-mp="9jfguwhjlv1u" />
              </a>
              <p className="text-sm text-white/60" data-id="element-167" data-mp="djzee16130oi">
                Or call{' '}
                <a href={contact.phoneHref} className="font-semibold text-white transition-colors duration-150 ease-premium hover:text-ice-400" data-id="element-168" data-mp="2g87mjooexz77">
                  {contact.phone}
                </a>
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}